<template>
  <div class="page-shell">
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
        <b-row>
          <b-col cols="4">
            <AutoBusca id="cliente" item_id="id" item_text="nome"
              item_campos="cli.id as id, cli.id|| '-' || TRIM(cli.nome) || '-'|| TRIM(cli.razao) || ' - ' || cli.cnpj  || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome"
              item_busca="cli.id|| '-' || COALESCE(TRIM(UPPER(cli.nome)),'') ||' - '|| COALESCE(TRIM(UPPER(cli.razao)),'') || '-' || TRIM(UPPER(cli.cnpj)) "
              item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid" tabela="cliente cli" :value="filtro_id_cli"
              @getID="getID" :label="'Digite o cliente'" :rdark="true" />
          </b-col>
          <b-col cols="8" class="d-flex flex-wrap align-center">
            <v-btn color="primary" class="mr-2 mb-2" @click="NovoCliente">
              <v-icon>mdi-plus</v-icon>
              Novo </v-btn>&nbsp;
            <v-btn color="error" class="mr-2 mb-2" @click="ExcluirClienteQuestion">
              <v-icon>mdi-delete</v-icon>
              Excluir </v-btn>&nbsp;
            <v-btn outlined class="mb-2" @click="TodosClientes">
              <v-icon>mdi-list-box</v-icon>
              Ver todos
            </v-btn>

          </b-col>
        </b-row>
      </v-card>

      <v-tabs v-model="tab" class="page-tabs">
        <v-tab v-for="item in items" :key="item.tab" v-show="getUser.nivel <= item.nivel">
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="painelContainer">
            <b-row>
              <b-col cols="5">
                <v-text-field label="Nome fantasia" placeholder="Não informado" outlined v-model="cliente.nome"
                  :value="cliente.nome" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field label="Razão Social" placeholder="Não informado" outlined v-model="cliente.razao"
                  :value="cliente.razao" hide-details="auto" maxlength="50"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field label="CNPJ/CPF" placeholder="Não informado" outlined v-model="cliente.cnpj"
                  hide-details="auto" maxlength="30" :value="cliente.cnpj"
                  v-mask="['###.###.###-##', '##.###.###-####/##']"></v-text-field></b-col>
              <b-col cols="3">
                <v-text-field label="Insc. Est" placeholder="Não informado" outlined v-model="cliente.insc_est"
                  :value="cliente.insc_est" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="Proprietário" placeholder="Não informado" outlined v-model="cliente.proprietario"
                  :value="cliente.proprietario" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="CPF" placeholder="Não informado" outlined v-model="cliente.cpf"
                  :value="cliente.cpf" hide-details="auto" maxlength="30" v-mask="['###.###.###-##']"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field label="CEP" placeholder="Não informado" outlined v-model="cliente.cep" hide-details="auto"
                  maxlength="10" :value="cliente.cep" v-mask="['#####-###']"></v-text-field>
              </b-col>
              <b-col cols="7">
                <v-text-field label="Rua/Avenida/Logradouro" placeholder="Não informado" outlined
                  v-model="cliente.endereco" :value="cliente.endereco" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="2">
                <v-text-field label="Número" placeholder="Não informado" outlined v-model="cliente.numero"
                  :value="cliente.numero" hide-details="auto"></v-text-field></b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field label="Bairro" placeholder="Não informado" outlined v-model="cliente.bairro"
                  :value="cliente.bairro" hide-details="auto"></v-text-field></b-col>
              <b-col cols="3">
                <v-text-field label="Complemento" placeholder="Não informado" outlined v-model="cliente.complement"
                  :value="cliente.complement" hide-details="auto"></v-text-field></b-col>
              <b-col cols="6">
                <AutoBusca id="cidade" item_id="codcid" item_text="nome"
                  item_campos="cid.codcid, TRIM(cid.nome)||'-'||cid.uf as nome"
                  item_busca="cid.codcid::text|| '-' || TRIM(UPPER(cid.nome)) " item_left="" tabela="cidade cid"
                  :value="cliente.id_cidade" @getID="getID" :label="'Digite a cidade'" :rdark="false" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <v-text-field label="Fone" placeholder="Não informado" outlined v-model="cliente.fone"
                  hide-details="auto" maxlength="15" :value="cliente.fone"
                  v-mask="['(##)####-####', '(##)#####-####']"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="Fone 2" placeholder="Não informado" outlined v-model="cliente.fone2"
                  hide-details="auto" maxlength="15" :value="cliente.fone2"
                  v-mask="['(##)####-####', '(##)#####-####']"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="E-Mail" placeholder="Não informado" outlined v-model="cliente.email"
                  :value="cliente.email" hide-details="auto"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="E-Mail Cobrança" placeholder="Não informado" outlined
                  v-model="cliente.email_cobranca" :value="cliente.email_cobranca" hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="painelContainer">
            <v-dialog v-model="modal_sigad" hide-overlay transition="dialog-top-transition" max-width="600">
              <v-card>
                <v-toolbar dark color="blue darken-3">
                  <v-toolbar-title>
                    Painel administrativo SIGAD
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <v-btn icon dark @click="modal_sigad = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <b-container>
                  <b-row>
                    <b-col cols="6">
                      <v-checkbox v-model="sigad.licenca" label="Licença ativa"
                        @change="AtivaProdutoSig('licenca')"></v-checkbox>
                    </b-col>
                    <b-col cols="6">
                      <small>Nro de emitidas</small><br />
                      {{ sigad.emitidas }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="2">
                      <v-checkbox v-model="sigad.nfe" label="NFe" @change="AtivaProdutoSig('signfe')"></v-checkbox>
                    </b-col>
                    <b-col cols="2">
                      <v-checkbox v-model="sigad.nfce" label="NFCe" @change="AtivaProdutoSig('signfce')"></v-checkbox>
                    </b-col>
                    <b-col cols="2">
                      <v-checkbox v-model="sigad.nfse" label="NFSe" @change="AtivaProdutoSig('signfse')"></v-checkbox>
                    </b-col>
                    <b-col cols="2">
                      <v-checkbox v-model="sigad.sigpos" label="SigPos"
                        @change="AtivaProdutoSig('sigpos')"></v-checkbox>
                    </b-col>
                    <b-col cols="2">
                      <v-checkbox v-model="sigad.sigpix" label="SigPix"
                        @change="AtivaProdutoSig('sigpix')"></v-checkbox>
                    </b-col>
                  </b-row>
                  <vs-divider></vs-divider>
                  <b-row>
                    <b-col cols="12">
                      <v-alert v-if="lblRetornoSigad != ''" type="success">
                        {{ lblRetornoSigad }}
                      </v-alert>
                    </b-col>
                  </b-row>
                  <!--
                   <b-row>
                    <b-col cols="12">
                      <v-btn
                        x-large
                        color="success"
                        @click="modal_sigad = true"
                      >
                        <v-icon>mdi-cogs</v-icon>
                        Salvar Informações
                      </v-btn>
                    </b-col>
                  </b-row> -->
                </b-container>
              </v-card>
            </v-dialog>

            <b-row>
              <b-col cols="3">
                <v-text-field label="Data início" placeholder="" outlined v-model="contrato.data_ini"
                  :value="contrato.data_ini" hide-details="auto" type="date"
                  :disabled="!usuarioPodeEditarDataFinal"></v-text-field>
              </b-col>
              <b-col cols="3">
                <v-text-field label="Data Final" placeholder="" outlined v-model="contrato.data_fin"
                  :value="contrato.data_fin" hide-details="auto" type="date"
                  :disabled="!usuarioPodeEditarDataFinal"></v-text-field>
              </b-col>
              <b-col cols="1" v-if="false">
                <InputNumeric id="dia_venc" label="Dia Vcto" :value="contrato.dia_venc" @onInput="getNumeric"
                  :nrodecimal="0" :enable="!usuarioPodeEditarDataFinal" />
              </b-col>
              <b-col cols="2">
                <AutoBuscaDrop id="bancos" item_id="codbco" item_text="nome" item_pk="codbco" item_campos="codbco,nome"
                  item_busca="codbco|| '-' || TRIM(UPPER(nome)) " item_left="" item_ordem="nome" item_condicao=""
                  tabela="bancos" :value="contrato.codbco" @getID="getID" :label="'Banco'"
                  :disable="!usuarioPodeEditarDataFinal" />
              </b-col>
              <b-col cols="2">
                <v-checkbox v-model="contrato.cartorio" label="Cartório"
                  :disabled="!usuarioPodeEditarDataFinal"></v-checkbox>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="4">
                    <InputNumeric id="valor" label="Valor Fixo" :value="contrato.valor" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_des" label="Valor Desconto" :value="contrato.valor_des"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_acr" label="Valor Acréscimo" :value="contrato.valor_acr"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <InputNumeric id="valor_sig" label="NFE Sig" :value="contrato.valor_sig" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_nfceb" label="NFCE Sig" :value="contrato.valor_nfceb" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <v-btn x-large color="grey" @click="
                      modal_sigad = true;
                    lblRetornoSigad = '';
                    ">
                      <v-icon>mdi-cogs</v-icon>
                      Painel SIGAD
                    </v-btn>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <InputNumeric id="valor_nfce" label="Nuvem SH" :value="contrato.valor_nfce" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_nfceb2" label="Nuvem KH" :value="contrato.valor_nfceb2"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_cts" label="Valor CTS" :value="contrato.valor_cts" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <InputNumeric id="valor_tef" label="Valor TEF" :value="contrato.valor_tef" @onInput="getNumeric"
                      :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_tef_smart" label="Valor TEF SMART" :value="contrato.valor_tef_smart"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                  <b-col cols="4">
                    <InputNumeric id="valor_smartpdv" label="Valor Smart PDV" :value="contrato.valor_smartpdv"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col cols="5">
                <b-row>
                  <b-col cols="6">
                    <v-text-field label="Data base" placeholder="" outlined v-model="contrato.data_base"
                      hide-details="auto" type="date" :disabled="!usuarioPodeEditarDataFinal"></v-text-field>
                  </b-col>
                  <b-col cols="6">
                    <InputNumeric id="valor_base" label="Valor Base Correção" :value="contrato.valor_base"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <v-text-field label="Data Atualização" placeholder="" outlined v-model="contrato.data_atu"
                      hide-details="auto" type="date" :disabled="!usuarioPodeEditarDataFinal"></v-text-field>
                  </b-col>
                  <b-col cols="6">
                    <InputNumeric id="valor_old" label="Valor anterior" :value="contrato.valor_old"
                      @onInput="getNumeric" :enable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <AutoBusca id="contratos" item_id="id" item_pk="cod_contrato" item_text="nome"
                      item_campos="cnt.cod_contrato as id, cnt.nome_cli as nome"
                      item_busca="cnt.cod_contrato::char|| '-' || TRIM(UPPER(cnt.nome_cli)) " item_left=""
                      tabela="contratos cnt" :value="contrato.cod_contrato" @getID="getID" :label="''"
                      :disable="disable_contrato || !usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <AutoBuscaDrop id="codsis" item_id="codigo" item_text="nome" item_pk="codigo"
                      item_campos="codigo,nome" item_busca="nome" item_left="" tabela="distrib sis"
                      :value="contrato.codsis" item_ordem="nome" item_condicao="" @getID="getID"
                      :label="'Digite o representante'" :rdark="false" :disable="!usuarioPodeEditarDataFinal" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <Editor v-model="contrato.obs" editorStyle="height: 100px" :readonly="!usuarioPodeEditarDataFinal">
                </Editor>
              </b-col>
            </b-row>
            <b-row> </b-row>
          </div>
        </v-tab-item>

        <v-tab-item>

          <v-btn block x-large @click="modal_semvalor = true">
            <v-icon>mdi-cogs</v-icon>&nbsp; Contratos sem valor definido
          </v-btn>
          <br>
          <v-btn block x-large @click="relContratosIF('data_fin')">
            <v-icon>mdi-cogs</v-icon>&nbsp; Contratos Finalizados
          </v-btn>
          <br>
          <v-btn block x-large @click="relContratosIF('data_ini')">
            <v-icon>mdi-cogs</v-icon>&nbsp; Contratos Iniciados
          </v-btn>

        </v-tab-item>
      </v-tabs-items>
    </v-list>

    <b-container fluid>
      <v-btn dark block color="grey darken-4" @click="SalvarCliente" v-if="aguardaContrato">
        <v-icon>mdi-account-check</v-icon>
        Salvar
      </v-btn>
    </b-container>
    <br />
    <v-dialog v-model="modal_todos" hide-overlay transition="dialog-top-transition" scrollable>
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10"> Todos os clientes </b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_todos = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <b-row>
              <b-col cols="6"></b-col>
              <b-col cols="6">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="12">
                <v-data-table :headers="headers" :items="clientes" class="elevation-1" :search="search" fixed-header
                  dense :style="{ width: '100%' }">
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" color="primary" @click="dblClickTodos(item)">
                      mdi-pencil </v-icon>&nbsp;
                    <v-icon small class="mr-2" color="error" @click="ExcluirCliente(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_semvalor" hide-overlay transition="dialog-top-transition" scrollable max-width="600">
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="5">
              <v-text-field v-model="ano_semvalor" label="Ano de inicio" single-line hide-details></v-text-field>
            </b-col>
            <b-col cols="5">
              <v-btn @click="SemValorClientes" filled color="grey" x-large>
                <v-icon>mdi-magnify</v-icon>Buscar
              </v-btn>
            </b-col>

            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_semvalor = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <v-divider></v-divider>
            <div v-for="(i, idx) in cliente_semvalor" :key="idx">
              <b-row>
                <b-col cols="10">
                  {{ i.nome }}
                </b-col>
                <b-col cols="2">
                  <v-icon small class="mr-2" @click="editarSemValor(i.id)">
                    mdi-pencil
                  </v-icon>
                </b-col>
              </b-row>
              <v-divider></v-divider>
            </div>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_exclusao" hide-overlay transition="dialog-top-transition" max-width="500">
      <v-card>
        <v-toolbar dark color="blue darken-3">
          <v-toolbar-title> Deseja Excluir ? </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modal_exclusao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <b-container>
          <b-row>
            <b-col>
              <h5>Deseja exclui o cliente - {{ cliente_exclusao }} ?</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <v-btn block dark color="red" @click="ExcluirCliente2">
                <v-icon>mdi-delete</v-icon> Excluir
              </v-btn>
            </b-col>
          </b-row>
        </b-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_cntTerminar" hide-overlay transition="dialog-top-transition" scrollable>
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="3">
              <v-text-field label="Data Inicial" placeholder="Não informado" outlined v-model="referencia"
                :value="referencia" hide-details="auto" type="month"></v-text-field>
            </b-col>
            <b-col cols="3">
              <v-text-field label="Data Final" placeholder="Não informado" outlined v-model="referencia2"
                :value="referencia2" hide-details="auto" type="month"></v-text-field>
            </b-col>

            <b-col cols="3">
              <v-btn x-large @click="BuscarContratosATerminar">
                <v-icon>mdi-list-box</v-icon>
                Buscar
              </v-btn>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col cols="1" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_cntTerminar = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text>
          <b-container fluid>
            <b-row>
              <b-col cols="6"></b-col>
              <b-col cols="6">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="12">
                <v-data-table :headers="headers" :items="cliente_contrato_terminar" class="elevation-1" :search="search"
                  fixed-header dense :style="{ width: '100%' }">
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="dblClickTodos(item)">
                      mdi-pencil </v-icon>
                  </template>
                </v-data-table>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import Vue from "vue";
import AutoBusca from "../components/AutoBusca.vue";
import AutoBuscaDrop from "../components/AutoBuscaDrop.vue";
import InputNumeric from "../components/InputNumeric.vue";
import Cliente from "../domain/Cliente";
import _Enum from "../obj/Enum";
import { mapGetters } from "vuex";
import Editor from "primevue/editor";

export default {
  components: {
    AutoBusca,
    AutoBuscaDrop,
    InputNumeric,
    Editor,
  },
  data: () => ({
    Enum: _Enum,
    cliente: {},
    contrato: {},
    filtro_id_cli: "",
    items: [
      { tab: "Cliente", nivel: 7 },
      { tab: "Contrato", nivel: 7 },
      { tab: "Relatórios", nivel: 7 },
    ],
    tab: 0,
    oper: "N",
    sigad: {
      nfe: false,
      nfce: false,
      nfse: false,
      sigpos: false,
      sigpix: false,
      licenca: false,
      emitidas: "",
    },
    disable_contrato: true,
    modal_sigad: false,
    lblRetornoSigad: "",
    modal_todos: false,
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: true,
        value: "id",
      },
      {
        text: "Nome",
        align: "start",
        sortable: true,
        value: "nome",
      },
      {
        text: "Razão",
        align: "start",
        sortable: true,
        value: "razao",
      },
      {
        text: "CNPJ/CPF",
        align: "start",
        sortable: true,
        value: "cnpj",
      },
      {
        text: "Cidade",
        align: "start",
        sortable: true,
        value: "cidade",
      },
      {
        text: "Fone",
        align: "start",
        sortable: true,
        value: "fone",
      },
      {
        text: "Ação",
        value: "actions",
      },
    ],
    clientes: [],
    search: "",
    modal_exclusao: false,
    cliente_exclusao: "",
    cliente_id_exclusao: null,
    modal_semvalor: false,
    ano_semvalor: "",
    cliente_semvalor: [],
    aguardaContrato: false,
    modal_cntTerminar: false,
    referencia: "",
    referencia2: "",
    campo: "",
    cliente_contrato_terminar: [],

  }),

  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    usuarioPodeEditarDataFinal() {
      const dataCnt = this.getUser ? this.getUser.data_cnt : false;

      return dataCnt === true || dataCnt === 1 || dataCnt === "1" || dataCnt === "true";
    },
  },

  created() {
    /* if (this.getUser.nivel > 1) {
      this.$router.replace({ name: "restrito" });
    } */
  },

  mounted() {
    this.NovoCliente();
  },

  methods: {

    getID(val) {
      if (val.id == "cliente") {
        if (val.value != null && val.value != "") {
          this.filtro_id_cli = val.value;
          this.buscaCliente(val.value);
        } else {
          this.NovoCliente();
        }
      }

      if (val.id == "contratos") {
        if (val.value != null && val.value != "") {
          this.contrato.cod_contrato = val.value;
          this.buscaContrato(val.value);
        } else {
          this.NovoContrato();
        }
      }

      if (val.id == "cidade") {
        if (val.value != null && val.value != "") {
          this.cliente.id_cidade = val.value;
        }
      }

      if (val.id == "bancos") {
        if (val.value != null && val.value != "") {
          this.contrato.codbco = val.value;
        }
      }

      if (val.id == "codsis") {
        console.log(val);
        if (val.value != null && val.value != "") {
          this.contrato.codsis = val.value;
        }
      }
    },

    getNumeric(val) {
      if (val.id == "valor") {
        this.contrato.valor = val.value;
      } else if (val.id == "valor_des") {
        this.contrato.valor_des = val.value;
      } else if (val.id == "valor_acr") {
        this.contrato.valor_acr = val.value;
      } else if (val.id == "valor_hora") {
        this.contrato.vlr_hor = val.value;
      } else if (val.id == "valor_sig") {
        this.contrato.valor_sig = val.value;
      } else if (val.id == "valor_nfceb") {
        this.contrato.valor_nfceb = val.value;
      } else if (val.id == "valor_tef") {
        this.contrato.valor_tef = val.value;
      } else if (val.id == "valor_nfce") {
        this.contrato.valor_nfce = val.value;
      } else if (val.id == "valor_nfceb2") {
        this.contrato.valor_nfceb2 = val.value;
      } else if (val.id == "dia_venc") {
        this.contrato.dia_venc = val.value;
      } else if (val.id == "valor_old") {
        this.contrato.valor_old = val.value;
      } else if (val.id == "valor_base") {
        this.contrato.valor_base = val.value;
      } else if (val.id == "valor_tef_smart") {
        this.contrato.valor_tef_smart = val.value;
      } else if (val.id == "valor_smartpdv") {
        this.contrato.valor_smartpdv = val.value;
      }
      else if (val.id == "valor_cts") {
        this.contrato.valor_cts = val.value;
      }
    },

    buscaCliente(id) {
      this.aguardaContrato = false;
      this.service = new Cliente(this.$resource);
      this.service.get(id).then(
        function (tmp) {
          if (tmp.cliente.length > 0) {
            this.cliente = tmp.cliente[0];
            this.contrato.cod_contrato = this.cliente.cod_contrato;
            if (
              this.contrato.cod_contrato == "" ||
              this.contrato.cod_contrato == null
            )
              this.NovoContrato();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    buscaContrato() {
      this.service = new Cliente(this.$resource);
      this.service.getContrato(this.filtro_id_cli).then(
        function (tmp) {
          if (tmp.length > 0) {
            this.contrato = tmp[0];
            this.contrato.data_ini = Vue.fData2(this.contrato.data_ini);
            this.contrato.data_fin = Vue.fData2(this.contrato.data_fin);
            this.contrato.data_base = Vue.fData2(this.contrato.data_base);
            this.contrato.data_atu = Vue.fData2(this.contrato.data_atu);
            this.contrato.obs = Vue.atob(this.contrato.obs);
            this.buscaStatusSig();
            this.aguardaContrato = true;
          } else {
            Vue.Mensagem(this, "Contrato", "Nenhum contrato encontrado");
            this.NovoContrato();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    buscaStatusSig() {
      var cnpj = this.cliente.cnpj;
      if (cnpj == "" || cnpj == null) return;
      var id = this.cliente.id;
      if (id == "" || id == null) return;

      this.service = new Cliente(this.$resource);
      this.service.getContratoStatus(cnpj, id).then(
        function (tmp) {
          var ret = tmp.split("|");
          if (ret[2].includes("signfe")) this.sigad.nfe = true;
          else this.sigad.nfe = false;
          if (ret[2].includes("signfce")) this.sigad.nfce = true;
          else this.sigad.nfce = false;
          if (ret[2].includes("signfse")) this.sigad.nfse = true;
          else this.sigad.nfse = false;
          if (ret[2].includes("sigpos")) this.sigad.sigpos = true;
          else this.sigad.sigpos = false;
          if (ret[2].includes("sigpix")) this.sigad.sigpix = true;
          else this.sigad.sigpix = false;

          /*
             LICENÇA  0-Não; 1-Sim
          */
          if (ret[1].includes("1")) this.sigad.licenca = true;
          else this.sigad.licenca = false;

          /*
             NUMEROS DE EMITIDAS
          */
          this.sigad.emitidas = ret[4]
            .toString()
            .substring(0, ret[4].length - 2);
        },
        (err) => {
          console.log(err);
        }
      );
    },

    AtivaProdutoSig(oper) {
      this.lblRetornoSigad = "";
      var cnpj = this.cliente.cnpj;
      if (cnpj == "" || cnpj == null) return;
      var fantasia = this.cliente.nome;
      if (fantasia == "" || fantasia == null) return;

      var id = this.cliente.id;

      var ativo = false;
      var operacao = oper;
      if (operacao == "licenca") ativo = this.sigad.licenca;
      else if (operacao == "signfe") ativo = this.sigad.nfe;
      else if (operacao == "signfce") ativo = this.sigad.nfce;
      else if (operacao == "signfse") ativo = this.sigad.nfse;
      else if (operacao == "sigpos") ativo = this.sigad.sigpos;
      else if (operacao == "sigpix") ativo = this.sigad.sigpix;

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.AtivaProdutos(cnpj, fantasia, operacao, ativo, id).then(
        function (tmp) {

          if (tmp.status != 200) {
            if (operacao == "licenca") this.sigad.licenca = !this.sigad.licenca;
            else if (operacao == "signfe") this.sigad.nfe = !this.sigad.nfe;
            else if (operacao == "signfce") this.sigad.nfce = !this.sigad.nfce;
            else if (operacao == "signfse") this.sigad.nfse = !this.sigad.nfse;
            else if (operacao == "sigpos") this.sigad.sigpos = !this.sigad.sigpos;
            else if (operacao == "sigpix") this.sigad.sigpos = !this.sigad.sigpix;
          }

          this.lblRetornoSigad = tmp.bodyText;
          Vue.CloseLoading(this);
        },
        (err) => {
          this.lblRetornoSigad = err;
          console.log(err);
        }
      );
    },

    NovoCliente() {
      this.cliente = this.getTmpCliente();
      this.cliente.id = "";
      this.filtro_id_cli = null;
      this.NovoContrato();
    },

    TodosClientes() {
      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.getTodos().then(
        function (tmp) {
          Vue.CloseLoading(this);
          this.clientes = tmp;
          this.modal_todos = true;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },

    editarSemValor(id) {
      this.filtro_id_cli = id;
      this.buscaCliente(id);
      this.modal_semvalor = false;
    },

    SemValorClientes() {
      if (this.ano_semvalor == "") {
        return;
      }

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.getSemValor(this.ano_semvalor).then(
        function (tmp) {
          Vue.CloseLoading(this);
          this.cliente_semvalor = tmp;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },

    ExcluirCliente(item) {
      //color, title, text, acceptText, cancelText, accept, cancel, vm)
      this.cliente_exclusao = item.nome;
      this.cliente_id_exclusao = item.id;
      this.modal_exclusao = true;
    },

    ExcluirCliente2() {
      //color, title, text, acceptText, cancelText, accept, cancel, vm)
      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.delete(this.cliente_id_exclusao).then(
        function () {
          Vue.CloseLoading(this);
          this.cliente_exclusao = "";
          this.cliente_id_exclusao = null;
          this.modal_exclusao = false;
          this.TodosClientes();
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },

    ExcluirCliente3() {
      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.delete(this.cliente_id_exclusao).then(
        function () {
          Vue.CloseLoading(this);
          this.cliente_id_exclusao = null;
          Vue.Mensagem(
            this,
            "Exclusão realizada",
            "O Cliente foi excluido com sucesso"
          );
          this.NovoCliente();
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },

    ExcluirClienteQuestion() {
      if (this.cliente.id == "" || typeof this.cliente.id == "undefined") {
        Vue.Mensagem(
          this,
          "Cliente não selecionado",
          "Selecione o cliente primeiro"
        );
        return;
      }

      this.cliente_id_exclusao = this.cliente.id;
      var vm = this;
      Vue.Pergunta(
        vm,
        "Excluir",
        "Deseja realmente excluir o cliente - " + vm.cliente.nome + "?",
        function () {
          vm.ExcluirCliente3();
        },
        null
      );
    },

    dblClickTodos(row) {
      this.filtro_id_cli = row.id;
      this.buscaCliente(row.id);
      this.modal_todos = false;
      this.modal_cntTerminar = false;
    },

    NovoContrato() {
      this.contrato = this.getTmpContrato();
      this.contrato.cod_contrato = "";
      this.aguardaContrato = true;
    },

    SalvarCliente() {
      var msg = "Deseja salvar ?";
      if (this.contrato.data_ini == null || this.contrato.data_ini == "")
        msg += " Data inicial do contrato não preenchida";
      if (this.contrato.codbco == null || this.contrato.codbco == "")
        msg += " Banco do contrato não preenchido";

      /* var i = this.contrato.valor +
        this.contrato.valor_sig +
        this.contrato.valor_nfceb +
        this.contrato.valor_tef +
        this.contrato.valor_nfce +
        this.contrato.valor_nfceb2 +
        this.contrato.valor_tef_smart +
        this.contrato.valor_smartpdv +
        this.contrato.valor_cts;

      if (i == 0 && this.contrato.data_fin == null || this.contrato.data_fin == "") {
        msg = "O contrato está sem valores definidos e sem data final. Deseja continuar ?";
      } */

      var vm = this;
      Vue.Pergunta(
        this,
        "Aviso",
        msg,
        function () {
          vm.SalvarCliente2();
        },
        null
      );
    },

    SalvarCliente2() {
      var _cli = JSON.parse(JSON.stringify(this.cliente));

      if (_cli.nome == "" || _cli.nome == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.razao == "" || _cli.razao == null) {
        Vue.Mensagem(this, "Campo inválido", "Nome precisa ser preenchido");
        return;
      }

      if (_cli.cnpj == "" || _cli.cnpj == null) {
        Vue.Mensagem(this, "Campo inválido", "CNPJ precisa ser preenchido");
        return;
      }

      if (_cli.id_cidade == "" || _cli.id_cidade == null) {
        Vue.Mensagem(this, "Campo inválido", "Cidade deve ser preenchida");
        return;
      }

      var _cnt = JSON.parse(JSON.stringify(this.contrato));
      _cnt.id_cli = _cli.nome;
      _cnt.nome = _cli.nome;
      _cnt.obs = Vue.btoa(_cnt.obs);

      var dados = [
        {
          cli: [_cli],
          cnt: [_cnt],
        },
      ];

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.save(dados).then(
        function (tmp) {
          if (tmp.codigo == 1) {
            Vue.Mensagem(this, "OK", "Operação realizada com sucesso");
            this.NovoCliente();
          } else Vue.Mensagem(this, "Atenção!", tmp.mensagem);

          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.Mensagem(this, "Erro", err);
        }
      );
    },

    getTmpCliente() {
      return {
        id: "",
        nome: "",
        razao: "",
        cnpj: "",
        insc_est: "",
        proprietario: "",
        cpf: "",
        cep: "",
        endereco: "",
        numero: "",
        bairro: "",
        complemento: "",
        id_cidade: "",
        fone: "",
        fone2: "",
        email: "",
        email_cobranca: "",
        codsis: ""
      };
    },

    getTmpContrato() {

      this.sigad = {
        nfe: false,
        nfce: false,
        nfse: false,
        sigpos: false,
        licenca: false,
        emitidas: "Não habilitado",
      };

      return {
        cod_contrato: "",
        id_cli: "",
        nome: "",
        data_ini: "",
        data_fin: "",
        valor: 0,
        valor_des: 0,
        valor_acr: 0,
        nro_fil: 0,
        dia_venc: 0,
        vlr_hor: 0,
        valor_sig: 0,
        valor_nfceb: 0,
        valor_tef: 0,
        valor_tef_smart: 0,
        valor_smartpdv: 0,
        valor_cts: 0,
        codbco: "",
        tp_fatur: "",
        codfor: "",
        data_base: "",
        valor_base: 0,
        data_atu: "",
        valor_old: 0,
        valor_nfce: 0,
        valor_nfceb2: 0,
        obs: "",
        cartorio: false,
      };
    },

    BuscarContratosATerminar() {

      if (this.referencia == "") {
        return;
      }

      Vue.Loading("", "", this);
      this.service = new Cliente(this.$resource);
      this.service.getContratosATermninar(this.referencia, this.referencia2, this.campo).then(
        function (tmp) {
          Vue.CloseLoading(this);
          console.log(tmp);
          this.cliente_contrato_terminar = tmp;
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );

    },

    relContratosIF(campo) {

      this.referencia = "";
      this.referencia2 = "";
      this.cliente_contrato_terminar = [];
      this.campo = campo;
      this.modal_cntTerminar = true;
    }



  },
};
</script>
